import React from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL, organizationJsonLd, ORG_ID } from "./Seo";
import { businessOrganizationJsonLd, BUSINESS_ID } from "../data/business/profile";

/** Site-niveau struktureret data. Lå tidligere statisk i index.html, hvilket betød at
 *  Votra Danmarks EducationalOrganization også blev udstillet på Votra Business-siderne.
 *  Nu afgør ruten hvilken juridisk enhed der præsenteres som sidens udgiver. */

const educationWebsite = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  "url": `${SITE_URL}/`,
  "name": "Votra Vognmandsuddannelser",
  "alternateName": "Votra Danmark ApS",
  "inLanguage": "da-DK",
  "publisher": { "@id": ORG_ID },
  "potentialAction": {
    "@type": "SearchAction",
    "target": { "@type": "EntryPoint", "urlTemplate": `${SITE_URL}/kurser?q={search_term_string}` },
    "query-input": "required name=search_term_string",
  },
};

const businessWebsite = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/business#website`,
  "url": `${SITE_URL}/business`,
  "name": "Votra Business",
  "alternateName": "Votra Business ApS",
  "inLanguage": "da-DK",
  "publisher": { "@id": BUSINESS_ID },
  "isPartOf": { "@id": `${SITE_URL}/#website` },
};

const SiteSchema = () => {
  const { pathname } = useLocation();
  const isBusiness = pathname === "/business" || pathname.startsWith("/business/");
  const blocks = isBusiness
    ? [businessWebsite, businessOrganizationJsonLd]
    : [organizationJsonLd, educationWebsite];

  // Renderes direkte i træet, ikke via useEffect. Effekter kører ikke under
  // build-tidens prerendering, og schemaet manglede derfor i den HTML, en klient
  // uden JavaScript fik. Blokkene ligger i #root, så React rydder selv op ved mount.
  return blocks.map((block, i) => (
    <script
      key={i}
      type="application/ld+json"
      data-votra-site-ld="1"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
    />
  ));
};

export default SiteSchema;
